import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { http, tithiName } from "@/lib/api";

export const TodayPanchang = () => {
  const { t, lang } = useLang();
  const [d, setD] = useState(null);
  useEffect(() => {
    const date = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    http.get("/panchang", { params: { date } }).then((r) => setD(r.data?.tithi ? r.data : null)).catch(() => setD(null));
  }, []);
  if (!d) return null;
  const today = new Intl.DateTimeFormat(lang, { weekday: "long", day: "numeric", month: "long" }).format(new Date(`${d.date}T12:00:00`));
  const items = [
    [t.panchang.tithi, `${tithiName(t, d.tithi.index)} · ${t.panchang.paksha[d.tithi.paksha]}`],
    [t.panchang.nakshatra, t.names.nakshatras[d.nakshatra.index]],
    [t.panchang.rahu, `${d.rahu_kaal.start} – ${d.rahu_kaal.end}`],
    [t.panchang.abhijit, `${d.abhijit.start} – ${d.abhijit.end}`],
    [`${t.panchang.sunrise} / ${t.panchang.sunset}`, `${d.sunrise} / ${d.sunset}`],
  ];
  return (
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 pt-10" data-testid="today-panchang">
      <Link to="/panchang" data-testid="today-panchang-link" className="card group block p-6 sm:p-8">
        <div className="flex flex-wrap items-baseline justify-between gap-3">
          <p className="eyebrow">{t.panchang.today} · {today} · Ghaziabad</p>
          <span className="inline-flex items-center gap-1 text-sm text-[color:var(--saffron)]">{t.panchang.title}<ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" /></span>
        </div>
        <dl className="mt-6 grid grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-5">
          {items.map(([k, v], i) => (
            <div key={k} data-testid={`today-panchang-${i}`} className={i === 4 ? "col-span-2 lg:col-span-1" : ""}>
              <dt className="lbl">{k}</dt>
              <dd className="display text-xl sm:text-2xl">{v}</dd>
            </div>
          ))}
        </dl>
      </Link>
    </div>
  );
};
